import { Button, FileInput, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
// import EquipmentListTable from './EquipmentListTable';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../Reducers/store';
import EquipmentApi from '../../Api/EquipmentApi';
import { File as ImageFile } from '../../Models/File';
import { MdCancel, MdCheckCircle } from 'react-icons/md';
import CommonApi from '../../Api/CommonApi';

export default function EquipmentImages({
  equipmentId,
}: {
  equipmentId: number;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [fileList, setFile] = useState<FileList | null>();
  const [imageFiles, setImageFiles] = useState<ImageFile[]>([]);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [isWatermarkChecked, setIsChecked] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  //   useEffect(() => {
  //     getEquipmentImageList();
  //   }, [userModel]);

  const getEquipmentImageList = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return EquipmentApi.getEquipmentImageList(equipmentId)
          .then((res) => {
            setImageFiles(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getEquipmentImageList();
  }, [getEquipmentImageList]);

  function handleRemoveImage(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this image?'
    );

    if (shouldRemove) {
      CommonApi.deleteFile(id)
        .then((res) => {
          if (res.data.success) {
            setImageFiles(imageFiles.filter((x) => x.id !== id));
            toast.success('Image deleted');
            getEquipmentImageList();
          } else {
            toast.success('Error while deleting image');
          }
        })
        .catch((err) => {
          toast.error('Image Error: ' + err);
        });
    }
  }

  function handleSetImagePrimary(id: number) {
    CommonApi.setFilePrimary(id)
      .then((res) => {
        if (res.data.success) {
          toast.success('Image set as Primary');
          getEquipmentImageList();
        } else {
          toast.success('Error while deleting image');
        }
      })
      .catch((err) => {
        toast.error('Image Error: ' + err);
      });
  }

  function handleImageChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      setFile(event.currentTarget.files);
    } else {
      setFile(null);
    }
  }

  const saveImages = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    try {
      if (fileList) {
        const fd = new FormData();
        Array.from(fileList).forEach((file) => {
          fd.append('file', file);
        });
        fd.append('equipmentId', equipmentId.toString());
        await EquipmentApi.uploadEquipmentImage(fd, isWatermarkChecked)
          .then((res) => {
            if (res.data.success) {
              getEquipmentImageList();
            }
          })
          .catch((err) => {
            toast.error('Image Error: ' + err);
          });
      }
      setIsLoading(false);
      setButtonDisabled(false);
      setFile(null);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='flex gap-2'>
          <div className='w-full'>
            <FileInput
              id='file-upload'
              helperText='PNG or JPG.'
              multiple
              onChange={handleImageChange}
              disabled={buttonDisabled}
            />
          </div>
          <div style={{ width: '200px', whiteSpace: 'nowrap' }}>
            <label>
              <input
                type='checkbox'
                checked={isWatermarkChecked}
                onChange={handleChange}
                className='nowrap'
              />
              Add Watermark
            </label>
          </div>
          <div>
            <Button
              disabled={buttonDisabled}
              type='button'
              className='buttonMain'
              onClick={() => saveImages()}
            >
              Upload
            </Button>
          </div>
        </div>
        <div className='flex flex-wrap gap-2'>
          {imageFiles &&
            imageFiles
              .sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary))
              .map((data) => (
                <div key={data.id + '-div'}>
                  <div className='h-56 sm:h-56 xl:h-64 border rounded-lg relative'>
                    <div className='w-full absolute top-2 flex justify-center gap-3'>
                      <Tooltip content='Delete Image'>
                        <button
                          key={data.id + '-deletebutton'}
                          type='button'
                          title='Delete Image'
                          onClick={() => handleRemoveImage(data.id)}
                          className='rounded-full bg-white'
                        >
                          <MdCancel color='red' size={20} />
                        </button>
                      </Tooltip>
                      {!data.isPrimary && (
                        <Tooltip content='Set as Primary'>
                          <button
                            key={data.id + '-primarybutton'}
                            type='button'
                            title='Set as Primary'
                            onClick={() => handleSetImagePrimary(data.id)}
                            className='rounded-full bg-white'
                          >
                            <MdCheckCircle color='green' size={20} />
                          </button>
                        </Tooltip>
                      )}
                    </div>
                    <img
                      key={data.id}
                      src={data.fileUrl!}
                      //   alt={formData.number + '-image'}
                      className='h-56 sm:h-56 xl:h-64 object-contain m-auto'
                    />
                  </div>
                </div>
              ))}
        </div>
      </div>
    </>
  );
}
